export default __webpack_public_path__ + "static/clustersetup2-0631d0b80cbf8b9cd7ee80efe63a99e5.png";